import React from "react"
import App from "../App.js"

export default function Home() {
  return <App></App>
}